module.exports = __webpack_public_path__ + "static/media/007.21959df3.jpg";